import { IDoctorAddress } from "../../interfaces/api";

const AddressTile = ({ data }: { data: IDoctorAddress }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "16px 16px 8px 16px",
        borderTop: "1px solid #D3E1F0",
      }}
    >
      <div>
        <div style={{ fontWeight: 600, paddingBottom: 8 }}>Address</div>
        {data.visitType === "Virtual" ? (
          <div>This PCP Offers Virtual Visits</div>
        ) : (
          <>
            <div>
              {data.standardized.address1} {data.standardized.address2}{" "}
            </div>
            <div>
              {data.standardized.city}, {data.standardized.state}{" "}
              {data.standardized.zip5}
            </div>
          </>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {data.isAcceptingNewPatients === "Yes" ? (
          <>
            <img
              src={
                (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                "/true.svg"
              }
              alt="yes"
              width={24}
              height={24}
            />
            <div style={{ paddingLeft: 8 }}>Accepting new patients</div>
          </>
        ) : data.panelDescription ? (
          data.panelDescription
        ) : (
          <>
            <img
              src={
                (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                "/false.svg"
              }
              alt="no"
              width={24}
              height={24}
            />
            <div style={{ paddingLeft: 8 }}>Accepting new patients</div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddressTile;
